import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchItem',
  props: {
  dataValue: {
    required: true
  }
},
  setup(__props) {

const props = __props

const refValue = ref(false)

onMounted(async () => {
  refValue.value = props.dataValue
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (typeof props.dataValue === 'string')
    ? (_openBlock(), _createBlock(_component_el_switch, {
        key: 0,
        modelValue: refValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refValue).value = $event)),
        "active-value": 'true',
        "inactive-value": 'false'
      }, null, 8, ["modelValue"]))
    : (_openBlock(), _createBlock(_component_el_switch, {
        key: 1,
        modelValue: refValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refValue).value = $event))
      }, null, 8, ["modelValue"]))
}
}

})